<template>
  <div class="">
    <router-view />
    <NotificationGroup group="foo">
      <div style="z-index: 10000" class="fixed  inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">
        <div class="w-full max-w-sm">
          <Notification
            v-slot="{ notifications }"
            enter="transform ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300">
            <div
              class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
              v-for="notification in notifications"
              :key="notification.id">
              <div class="flex items-center justify-center w-12" :class="notification.variant">
                <svg class="w-6 h-6 text-white fill-current" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z" />
                </svg>
              </div>

              <div class="px-4 py-2 -mx-3">
                <div class="mx-3">
                  <p class="text-sm text-gray-600">{{ notification.text }}</p>
                </div>
              </div>
            </div>
          </Notification>
        </div>
      </div>
    </NotificationGroup>
  </div>
</template>
<script setup>
import { computed, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { useAccountStore } from './stores/account';

const CustomerId = computed(() => useAccountStore().CustomerId);
const DistributorId = computed(() => useAccountStore().DistributorId);
const DistributorName = computed(() => useAccountStore().DistributorName);

const appName = computed(() => DistributorName.value ?? '\'Nani');

const route = useRoute();
const path = computed(() => route.path);

const analyticsPayload = computed(() => {
  const distributorId = DistributorId.value;
  const customerId = CustomerId.value;
  if (!(distributorId || customerId)) return null;
  return ({
    customerId,
    distributorId,
    path: path.value,
  });
});

const { umami } = window;

watch(analyticsPayload, (newV) => {
  if (!newV) return;
  umami.track((props) => ({
    ...props,
    website: import.meta.env.VITE_UMAMI_SITE_ID,
    url: `/${DistributorId.value}`,
  }));
}, { immediate: true, deep: true });

watch(appName, (newV) => {
  document.title = `${newV}`;
}, {
  immediately: true,
});
</script>

<style>
* {
  transition: all ease-in-out 0.20s !important;
}

#application {
  width: 350px;
}
</style>
